export enum EContactView {
  CONTACT = 'contact',
  ERROR = 'error',
  BANNER = 'banner',
}
